export default __webpack_public_path__ + "static/media/tf.2ac54413.jpg";